import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const CloudUpload: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox='0 0 60 60'>
      <path
        d='M52.4779 24.585L52.5 24.375C52.5 15.0564 44.9471 7.5 35.625 7.5C29.3621 7.5 23.9586 10.95 21.0486 16.0164C19.7814 15.39 18.3829 15 16.875 15C11.6964 15 7.5 19.1964 7.5 24.375L7.52215 24.585C3.05285 27.1871 0 31.98 0 37.5C0 45.7536 6.75363 52.5 15 52.5H26.25V37.5H18.75L30 22.5L41.25 37.5H33.75V52.5H45C53.2536 52.5 60 45.7536 60 37.5C60 31.98 56.9471 27.1871 52.4779 24.585Z'
        fill={props.fill}
      />
    </SvgIcon>
  );
};
